import { relations } from 'drizzle-orm';
import { pgTable, primaryKey, uuid, boolean } from 'drizzle-orm/pg-core';
import { userTable } from './user.sql';
import { teamTable } from './team.sql';

export const userTeamNotificationSettingTable = pgTable(
  'user_team_notification_setting',
  {
    userId: uuid('userId')
      .notNull()
      .references(() => userTable.id),
    teamId: uuid('teamId')
      .notNull()
      .references(() => teamTable.id),
    notification: boolean('notification').notNull().default(true),
  },
  (t) => [primaryKey({ columns: [t.teamId, t.userId] })],
);

export const userTeamNotificationSettingRelations = relations(
  userTeamNotificationSettingTable,
  ({ one }) => ({
    user: one(userTable, {
      fields: [userTeamNotificationSettingTable.userId],
      references: [userTable.id],
    }),
    team: one(teamTable, {
      fields: [userTeamNotificationSettingTable.teamId],
      references: [teamTable.id],
    }),
  }),
);
